module.exports = __webpack_public_path__ + "img/web_neipu_1.0220f1ec.jpg";